import { useQuery } from '@tanstack/react-query';
import { api } from '../lib/api-client';
import { queryKeys } from '../lib/query-keys';

// ── DTOs ──

export interface DashboardKPIs {
  proyectos_activos: number;
  proformas_pendientes: number;
  planillas_pendientes: number;
  pedidos_pendientes: number;
  total_pagos_mes: number;
}

export interface ProjectSummaryDTO {
  project_id: string;
  codigo: string;
  nombre: string;
  estado: string;
  client_nombre: string;
  residente_nombre: string | null;
  total_pagos: number;
  total_proforma: number;
  total_ejecutado_proforma: number;
  porcentaje_ejecucion_proforma: number;
  planillas_pendientes: number;
}

export interface DashboardDTO {
  kpis: DashboardKPIs;
  projects_summary: ProjectSummaryDTO[];
}

// ── Hook ──

export function useDashboard() {
  return useQuery({
    queryKey: queryKeys.dashboard.summary,
    queryFn: async () => {
      const response = await api.get<{ data: DashboardDTO }>('/dashboard');
      return response.data.data;
    },
    refetchInterval: 60_000, // Refresh every 60s
  });
}
